module.exports = __webpack_public_path__ + "img/molecule-full-empty.e70f163d.png";